export const createNewSection = () => ({
  section_title: '',
  modules: [
    {
      module_title: '',
      content_type: 'info',
      element_id: null,
      goals: [],
      attachment: null,
    },
  ],
})

export const createNewModule = () => ({
  module_title: '',
  content_type: 'info',
  element_id: null,
  document_following: 'noDocument',
  goals: [],
  attachment: null,
})

export const addSection = sections => {
  const newSections = [...sections]
  newSections.push(createNewSection())
  return newSections
}

export const removeSection = (sections, sectionIndex) => {
  const newSections = [...sections]
  newSections.splice(sectionIndex, 1)
  return newSections
}

export const updateSectionTitle = (sections, sectionIndex, title) => {
  const newSections = [...sections]
  newSections[sectionIndex].section_title = title
  return newSections
}

export const addModule = (sections, sectionIndex) => {
  const newSections = [...sections]
  newSections[sectionIndex].modules.push(createNewModule())
  return newSections
}

export const removeModule = (sections, sectionIndex, moduleIndex) => {
  const newSections = [...sections]
  newSections[sectionIndex].modules.splice(moduleIndex, 1)
  return newSections
}

export const updateModuleTitle = (
  sections,
  sectionIndex,
  moduleIndex,
  title,
) => {
  const newSections = [...sections]
  newSections[sectionIndex].modules[moduleIndex].module_title = title
  return newSections
}

export const addGoal = (sections, sectionIndex, moduleIndex, goalText = '') => {
  const newSections = [...sections]
  const module = newSections[sectionIndex].modules[moduleIndex]

  // Don't add goals to survey or quiz modules
  if (module.content_type === 'survey' || module.content_type === 'quiz') {
    return newSections
  }

  ensureGoalsArray(module)
  module.outline.push(goalText)
  return newSections
}

export const removeGoal = (sections, sectionIndex, moduleIndex, goalIndex) => {
  const newSections = [...sections]
  const module = newSections[sectionIndex].modules[moduleIndex]

  // Don't remove goals from survey or quiz modules
  if (module.content_type === 'survey' || module.content_type === 'quiz') {
    return newSections
  }

  if (module.outline) {
    module.outline.splice(goalIndex, 1)
  }
  return newSections
}

export const updateGoal = (
  sections,
  sectionIndex,
  moduleIndex,
  goalIndex,
  text,
) => {
  const newSections = [...sections]
  const module = newSections[sectionIndex].modules[moduleIndex]

  // Don't update goals for survey or quiz modules
  if (module.content_type === 'survey' || module.content_type === 'quiz') {
    return newSections
  }

  ensureGoalsArray(module)
  module.outline[goalIndex] = text
  return newSections
}

export const duplicateSectionData = section => ({
  ...section,
  section_title: `${section.section_title} (Copy)`,
  modules: section.modules.map(module => ({
    ...module,
    module_title: `${module.module_title} (Copy)`,
  })),
})

export const duplicateModuleData = module => ({
  ...module,
  module_title: `${module.module_title} (Copy)`,
})

export const ensureGoalsArray = module => {
  // For survey and quiz modules, ensure they have no goals
  if (module.content_type === 'survey' || module.content_type === 'quiz') {
    module.outline = []
    return module
  }

  if (!module.outline || module.outline === null) {
    module.outline = []
  }
  return module
}
